export function Assert(condition: boolean, message: string, ...args: any[]): void {
    if (condition) {
        return;
    }

    throw Error(message.replace(/{(\d+)}/g, (match, matchIndex) => (args[matchIndex] ? args[matchIndex] : match)));
}
